import React from 'react'
import { Button, Divider, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import TextStyleControls from './TextStyleControls'
import { BoxSizeControls, BarFillControl, ImageSizeControls } from './TypeControls'
import { SPONSORS_FIELD_ID } from './overlayEditorControls'

const typeOf = (field) => (['Image', 'Bar', 'ColorBox'].includes(field?.dataType) ? field.dataType : 'Text')

// Properties panel for two or more selected fields: one section per type in the
// selection, plus remove. The sponsors area has its own layout controls, so it is
// edited on its own.
export default function MultiSelectPanel({ ids, placements, fields, aspectLocked, onLockChange, onPatch, onRemove }) {
  const targets = ids
    .map((id) => ({ placement: placements.find((p) => p.fieldId === id), field: fields.find((f) => f.key === id) }))
    .filter((t) => t.placement)
  const editable = targets.filter((t) => t.placement.fieldId !== SPONSORS_FIELD_ID)
  const byType = (type) => editable.filter((t) => typeOf(t.field) === type)
  const patchFor = (list) => (fn) => onPatch(list.map((t) => t.placement.fieldId), fn)

  const sections = [
    {
      type: 'Text', title: 'Text',
      render: (list) => (
        <>
          <TextStyleControls targets={list} onPatch={patchFor(list)} />
          <BoxSizeControls targets={list} onPatch={patchFor(list)} />
        </>
      ),
    },
    {
      type: 'Bar', title: 'Bars',
      render: (list) => (
        <>
          <BarFillControl targets={list} onPatch={patchFor(list)} />
          <BoxSizeControls targets={list} onPatch={patchFor(list)} />
        </>
      ),
    },
    { type: 'ColorBox', title: 'Color boxes', render: (list) => <BoxSizeControls targets={list} onPatch={patchFor(list)} /> },
    {
      type: 'Image', title: 'Images',
      render: (list) => (
        <ImageSizeControls targets={list} isLocked={aspectLocked} onLockChange={onLockChange} onPatch={patchFor(list)} />
      ),
    },
  ].map((section) => ({ ...section, list: byType(section.type) })).filter((section) => section.list.length > 0)

  const skipped = targets.length - editable.length

  return (
    <>
      <div style={{ padding: '8px 12px 4px' }}>
        <Typography variant='subtitle2'>{ids.length} fields selected</Typography>
        {skipped > 0 && (
          <Typography variant='caption' color='textSecondary' style={{ display: 'block' }}>
            The sponsors area is edited on its own.
          </Typography>
        )}
      </div>
      {sections.map((section) => (
        <div key={section.type}>
          {sections.length > 1 && (
            <div style={{ padding: '8px 12px 2px' }}>
              <Typography variant='caption' color='textSecondary' style={{ fontWeight: 500 }}>
                {section.title} ({section.list.length})
              </Typography>
            </div>
          )}
          {section.render(section.list)}
        </div>
      ))}
      <Divider style={{ margin: '8px 0 4px' }} />
      <div style={{ padding: '4px 12px' }}>
        <Button
          size='small'
          color='secondary'
          startIcon={<DeleteIcon style={{ fontSize: 16 }} />}
          onClick={() => onRemove(ids)}
          style={{ fontSize: 11 }}
        >
          Remove {ids.length} fields
        </Button>
      </div>
    </>
  )
}
